<script>
export default {
  name: 'ContentGroup',
  props: {
    title: {
      type: String,
      default: '',
    },

    count: {
      type: Number,
      default: 0,
    },

    isFull: {
      type: Boolean,
      default: false,
    },

    titleOfViewmore: {
      type: String,
      default: '',
    },

    limit: {
      type: Number,
      default: 3,
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  watch: {
    isFull(v) {
      this.isOpen = v;
    },
  },

  mounted() {
    this.isOpen = this.isFull;
  },

  methods: {
    onToggle() {
      this.isOpen = !this.isOpen;
      this.$emit('show', this.isOpen);
    },
  },
};
</script>
<template>
  <div class="tw-mt-4">
    <div class="tw-font-bold">{{ title }}</div>
    <div class="tw-mt-3">
      <slot />
    </div>
    <div v-if="count && count > limit" class="tw-mt-4 tw-text-center">
      <div
        class="tw-inline-block tw-text-purple-600 hover:tw-text-purple-800 tw-text-sm tw-leading-5 tw-font-bold tw-cursor-pointer"
        @click="onToggle"
      >
        <div v-if="isOpen">
          Less
          {{
            count === 1 || !titleOfViewmore
              ? title.toLowerCase()
              : titleOfViewmore.toLowerCase()
          }}
        </div>
        <div v-else>
          See all {{ count }}
          {{
            count === 1 || !titleOfViewmore
              ? title.toLowerCase()
              : titleOfViewmore.toLowerCase()
          }}
        </div>
      </div>
    </div>
  </div>
</template>
